import {gsap} from "gsap";
import {RoadKill} from "../RoadKill";
import {RoadKillGameMode} from "../server/RoadKillGameMode";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {RoadKillModel} from "../server/RoadKillModel";

export class RoadKillFreespinIntroRunner implements SimplePresentation {
    private static fsIntroClosedCallback(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }

    public shouldRun(): boolean {
        let returnValue: boolean = false,
            mode: string = RoadKill.model.mode,
            nextMode: string = RoadKill.model.nextMode;
        if (mode === RoadKillGameMode.NORMAL && nextMode === RoadKillGameMode.FREESPIN) {
            return true;
        }
        if (mode === RoadKillGameMode.NORMAL && nextMode === RoadKillGameMode.RESPIN) {
            return true;
        }
        if (mode === RoadKillGameMode.NORMAL && nextMode === RoadKillGameMode.SUPER_FREESPIN) {
            return true;
        }
        if (mode === RoadKillGameMode.RESPIN && nextMode === RoadKillGameMode.FREESPIN && !RoadKill.model.isRestore) {
            return true;
        }
        if (mode === RoadKillGameMode.FREESPIN && nextMode === RoadKillGameMode.SUPER_FREESPIN) {
            return true;
        }
        if (RoadKill.model.isRestore) {
            if (mode === RoadKillGameMode.RESPIN && nextMode === RoadKillGameMode.RESPIN) {
                return true;
            }
            if (mode === RoadKillGameMode.FREESPIN && nextMode === RoadKillGameMode.FREESPIN) {
                return true;
            }
            if (mode === RoadKillGameMode.SUPER_FREESPIN && nextMode === RoadKillGameMode.SUPER_FREESPIN) {
                return true;
            }
        }
        return returnValue;
    }

    public start(controller: SimplePresentationRunnerController): void {
        const mainTL: TimelineMax = gsap.timeline();
        mainTL.add(() => {
            RoadKill.initialWinView.hideCountUp()
            RoadKill.bigWinView.hideCountUp();
            RoadKill.fsIntroView.showIntro(() => RoadKillFreespinIntroRunner.fsIntroClosedCallback(controller));
            !RoadKill.model.isRestore && RoadKill.jumpingWildView.onModeChange(RoadKill.model.data.nextMode);
        });
    }
}